import List from 'src/constrains/SalesChannelContent-Revamp/ModuleList';
import React from 'react';
import { Form } from 'src/components/RcForm';
import { orderKey } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive/constants';

const ModulesList = (props) => {
  const {
    form,
    onClick,
    onAdd,
    errorDisplay,
    onDelete,
    onDuplicate,
    selectedItem,
    visibleDisplay,
    disabled,
  } = props;
  return (
    <Form form={form}>
      <List
        listKey={orderKey}
        listForm={form}
        onClick={onClick}
        onAdd={onAdd}
        onDelete={onDelete}
        onDuplicate={onDuplicate}
        selectedItem={selectedItem}
        //
        errorDisplay={errorDisplay}
        visibleDisplay={visibleDisplay}
        disabled={disabled}
      />
    </Form>
  );
};
export default ModulesList;
